module.exports = __webpack_public_path__ + "static/media/avatarAmy.e027e762.jpg";